// Accordion do detalhe Guia de Preparo.
// Entry em javascripts/pages porque o build não reconhece subpastas.

const setGuiaAccordion = () => {
  const roots = document.querySelectorAll('[data-rd-guia-accordion]');
  if (!roots.length) return;

  roots.forEach((root) => {
    root.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-rd-guia-acc-trigger]');
      if (!trigger || !root.contains(trigger)) return;

      const item = trigger.closest('[data-rd-guia-acc-item]');
      if (!item) return;

      const panel = item.querySelector('[data-rd-guia-acc-panel]');
      if (!panel) return;

      const willOpen = !item.classList.contains('is-open');

      item.classList.toggle('is-open', willOpen);
      trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');

      if (willOpen) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  });
};

window.addEventListener('DOMContentLoaded', () => {
  setGuiaAccordion();
});
